export const messages = {
  de: require('./de.json'),
  en: require('./en.json'),
}
